export default "__VITE_ASSET__ClaY986x__"